import http from './http'

export default class occupationApi {
  static getOccupations(endpoint) {
    return http.get(endpoint)
  }
}
